export function justNumbers(str:string){
    if(typeof(str)!=='string')return '';
    let ret="";
    for(let i=0;i<str.length;i++){
     const char=str.charCodeAt(i);
     if(char<48||char>57)
         continue;
     ret+=str[i];
    }
    return ret;
 }